
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TagMultiselectItem from "@/components/projects/Tags/TagMultiselectItem.vue";
import TagsMultiselect from "@/components/autocompleteMultiselects/TagsMultiselect.vue";

interface TagsMultiselectOptions {
  id: number;
  name: string;
}

@Component({
  components: {
    TagsMultiselect,
    TagMultiselectItem,
  },
})
export default class CustomTagsMultiselect extends Vue {
  @Prop({ type: Array, required: true })
  readonly previouslyChosenTagsIds!: number[];
  @Prop({ type: String, default: "" })
  readonly getParentcontainerStyle?: string;
    @Prop({ type: Number, default: undefined }) readonly max?: number;
  @Prop({ type: String, default: "Add new tags" })
  readonly customTagLabel!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  newTagsNames: string[] = [];
  tagsIdsFromDB: number[] = [];
  searchQuery: string = "";

  @Watch("previouslyChosenTagsIds", { immediate: true })
  onTagsIdsChanged(): void {
    this.tagsIdsFromDB = this.previouslyChosenTagsIds;
  }

  search(query: string) {
    this.searchQuery = query;
  }

mounted(){
   this.tagsIdsFromDB = this.previouslyChosenTagsIds;
}
  updateTagList(
    allChosenTags: TagsMultiselectOptions[],
    newTags: number[]
  ): void {
    this.$emit("tagsListUpdated", allChosenTags, newTags);
  }
}
